import * as Yup from "yup";
export var optionalEmail = function () {
    return Yup.string().email("Must be a valid email address");
};
export var requiredEmail = function () { return optionalEmail().required("Cannot be blank"); };
